import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, HelloWorldControlPanelKey } from "../../redux/actions/controlPanelActions";

import configData from "../../config/config.json";
import { ALERT_TYPES, LOADING_STATUES } from "../constants/constants";
import Confirmation from '../common/modal/Confirmation';
import Loading from '../common/modal/Loading';
import Alert from '../common/modal/Alert';
import { formatPhone } from "../common/function/formattingUtils.js";

const componentName = HelloWorldControlPanelKey;

const matchDispatchToProps = (dispatch) => {
  return {
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
  }
}

class HelloWorld extends Component {

  state = {
    phoneNumber: "",
    message: "",
    showAlert: false,
    alertMessage: "",
    showConfirmationDialog: false,
    loadingStatus: "",
    errors: {}
  }

  showAlert = (alertMessage) => {
    this.setState({
      showAlert: true,
      alertMessage
    })
  }

  hideAlert = () => {
    this.setState({
      showAlert: false,
      alertMessage: ""
    })
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  handleConfirmTexting = () => {
  
    if (this.showLoading() === true) {
      let request = {
        phoneNumber: this.state.phoneNumber
      };

      axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/helloWorld", request, { withCredentials: true })
        .then(
          (response) => {
            this.setState({
              loadingStatus: '',
              alertType: ALERT_TYPES.OK
            }, this.showAlert(response.data.message));
          },
          (error) => {
            this.setState({
              loadingStatus: '',
              alertType: ALERT_TYPES.WARNING
            }, this.showAlert(error.response.data.message));
          }
        );
    }
  }

  showConfirmation = (event) => {
    event.preventDefault();
    this.setState({
      showConfirmationDialog: true
    })
  }

  hideConfirmation = () => {
    this.setState({
      loadingStatus: '',
      showConfirmationDialog: false
    })
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.showConfirmation(event);
  }

  handleChange = (event) => {
    event.preventDefault();

    let value = event.target.value;
    if (event.target.id === 'phoneNumber') {
      value = formatPhone(value, this.state.phoneNumber);
    }

    this.setState({
      [event.target.id]: value,
      errors: {}
    })
  }

  showAlert = (alertMessage) => {
    this.setState({
      showAlert: true,
      alertMessage
    })
  }

  hideAlert = () => {
    this.setState({
      showAlert: false,
      alertMessage: ""
    })

    if (this.state.redirect) {
      this.props.history.push('/controlPanel/alerts');
    }
  }

  componentDidMount() {
    this.props.setSelectedControlPanelType();
  }

  render() {

    const formProps = {
      componentName: componentName,
      pageHeading: "Hello World Test",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      loadingIndicator: this.state.loadingStatus === LOADING_STATUES.LOADING,
      message: this.state.message,
      formGroupRows: [
        {
          formGroups: [{ id: 'phoneNumber', label: 'Phone Number', fieldType: 'text', required: true, value: this.state.phoneNumber }]
        }
      ]
    }


    return (
      <>
        <FormTemplate {...formProps} />
        <Confirmation show={this.state.showConfirmationDialog} cancelConfirmation={this.hideConfirmation} proceedConfirmation={this.handleConfirmTexting} question={'Sending a test text.  Continue?'} />
        <Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
        <Alert type={this.state.alertType} show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />
      </>
    );
  }
}

export default connect(null, matchDispatchToProps)(HelloWorld);